<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/en/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Drug Screening Core</span></p>'
      //+ '<div style="margin-left : 40px; margin-bottom: 20px"><div style="font-size: 20px;"><b style="color: #033d80; "> | </b> 简介</span></p>'
      + '<p>&nbsp;</p>'

      + '<div id="left" style="float:left ; width:75%; height:100%;">'
      + '<p style="margin-bottom : 20px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Drug Screening Core provides molecule design, screen and optimization for drug development, as well as tailored treatment relevant to personalized medicine in clinic practice, with a particular focus on oncology, cardiovascular and metabolic diseases. Equipped with a variety of target-specific compounds library, and self-designed automat- ed drug screening workstations, our core routinely conducts comprehensive drug optimi- zation and evaluation. With integrated systems pharmacology, structure-based parallel medicinal and computational chemistry technology, we are able to perform drug development research at the molecular, cellular and orgasm levels. Meanwhile, we use target-known compounds as chemical probes to decipher disease-related signaling pathways.</sspan></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 18px; ">联系人</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; color: #033d80; ">姓名：崔祎赟</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; ">邮箱：cyysjtu@sjtu.edu.cn</span></p>'
      // + '<p style="text-align: left; margin-left : 180px"><span style="font-size: 16px; ">电话：17740823635</span></p>'
      + '</div>'


      + '<div id="right" style="float:left ; width:25%; height:100%;">'
      + '<p style="margin-left : 40px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/zhangjianming.jpg" style="float: left; width: 200px; margin-right: 30px; margin-top:20px;" border="0" vspace="0" alt=""></p>'
      + '<p style="margin-left : 50px;text-align: justify"><span style="font-size: 16px;"><b>Director: Zhang Jianming</b></span></p>'
      + '</div>'
      + '<p>&nbsp;</p>'

      + '<div>'
      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> &nbsp;&nbsp;&nbsp; Automated Drug Screening&nbsp;&nbsp;&nbsp; </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment: Automatic liquid handler, ultrasensitive microplate detection system, multi parameter high-content analysis system.</span></p>'
      + '<p style="margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services:</span></p>'
      + '<ul>' +
      '<li style="list-style-type : disc; margin-bottom : 5px; margin-left: 30px; font-size: 16px;">High throughput screening on biochemical at cellular and model organism level</li>' +
      '<li style="list-style-type : disc; margin-bottom : 25px; margin-left: 30px; font-size: 16px;">Custom-made compound library</li>' +
      '</ul>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> &nbsp;&nbsp;&nbsp; Drug Optimization &nbsp;&nbsp;&nbsp;</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment: High diversity compound library, Virtual screening system, Medicinal chemistry.</span></p>'
      + '<p style="margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services:</span></p>'
      + '<ul>' +
      '<li style="list-style-type : disc; margin-bottom : 5px; margin-left: 30px; font-size: 16px;">Synthesis of organic compound/probe</li>' +
      '<li style="list-style-type : disc; margin-bottom : 5px; margin-left: 30px; font-size: 16px;">lead compound optimization</li>' +
      '<li style="list-style-type : disc; margin-bottom : 25px; margin-left: 30px; font-size: 16px;">patent application</li>' +
      '</ul>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> Preclinical Efficacy Evaluation </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment: Custom protein expression and purification system, molecular interaction analyz- er, cell and tissue culture system.</span></p>'
      + '<p style="margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services:</span></p>'
      + '<ul>' +
      '<li style="list-style-type : disc; margin-bottom : 25px; margin-left: 30px; font-size: 16px;">Pharmacokinetic and pharmacodynamics evaluation</li>' +
      '</ul>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> Preclinical Efficacy Evaluation </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Key Equipment: High performance liquid chromatography, high resolution mass spectrometer, nucle- ar magnetic resonance spectrometer.</span></p>'
      + '<p style="margin-right : 20px;text-align: justify"><span style="font-size: 16px">Services:</span></p>'
      + '<ul>' +
      '<li style="list-style-type : disc; margin-bottom : 5px; margin-left: 30px; font-size: 16px;">Drug analysis</li>' +
      '<li style="list-style-type : disc; margin-bottom : 5px; margin-left: 30px; font-size: 16px;">pharmacology and toxicology research</li>' +
      '<li style="list-style-type : disc; margin-bottom : 5px; margin-left: 30px; font-size: 16px;">DMPK</li>' +
      '<li style="list-style-type : disc; margin-bottom : 15px; margin-left: 30px; font-size: 16px;">Identification of metabolites</li>' +
      '</ul>'

      + '<p style="text-align: center;"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/drug_screening_core_1.en.jpg" style="float: left; width: 800px; " border="0" vspace="0" ></p>'

      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">Contact</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Zhang Qianqian</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Email: zhangqianmengjie@outlook.com</span></p>'

      + '</div>'

      + '<p>&nbsp;</p><p>&nbsp;</p>'
},
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service8/en/index.vue